<!-- =========================================================================================
    File Name: Table.vue
    Description: Table demo - Imports all table demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div>
    <vx-card ref="filterCard" class="user-list-filters mb-8" collapse-action>
      <ValidationObserver v-slot="{ invalid }">
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3 flex">
            <div class="flex-1 pr-1">
              <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.year") }}</label>
              <v-select v-model="form.year" :clearable="false" :options="yearsOptions" name="year" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
            <div class="flex-1">
              <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.month") }}</label>
              <v-select v-model="form.month" :clearable="false" :options="monthsOptions" name="month" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
            </div>
          </div>
          <div class="vx-col w-2/3">
            <label class="text-sm opacity-75">{{ $t("sections.accounting.dataForm.project") }}</label>
            <v-select v-model="form.project" :clearable="true" :options="projectOptions" name="project" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="vx-row mb-2">
          <div class="vx-col w-1/3">
            <label class="text-sm opacity-75">{{$t('sections.report.dataForm.faculty')}}/{{$t('sections.report.dataForm.curriculum')}}</label>
            <v-select v-model="form.curriculum" :clearable="true" :options="facultyCurriculumOptions" name="curriculum" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-1/3">
            <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.loan.loanType") }}</label>
            <v-select v-model="form.loanType" :clearable="true" :options="loanTypesOptions" name="loanType" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
          <div class="vx-col w-1/3">
            <label class="text-sm opacity-75">{{ $t("sections.report.dataForm.educationStatus") }}</label>
            <v-select v-model="form.educationStatus" :clearable="true" :options="educationStatusesOptions" name="educationStatus" :reduce="res => res.value"  :dir="$vs.rtl ? 'rtl' : 'ltr'" />
          </div>
        </div>
        <div class="vx-row mb-2 flex">
          <div class="vx-col ml-auto">
            <vs-button color='success' @click="download()" class="mr-2">{{ $t("general.download") }}</vs-button>
            <vs-button color='warning' @click="reset()">{{ $t("general.reset") }}</vs-button>
          </div>
        </div>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createNamespacedHelpers, mapGetters } from 'vuex'
import vSelect from 'vue-select'
import { getReportDate } from '@/utils'
const { mapActions: mapReportActions, mapState: mapReportState } = createNamespacedHelpers('Report')
const { mapActions: mapMasterActions, mapState: mapMasterState } = createNamespacedHelpers('Master')
const moment = require('moment');

export default {
  components: {
    vSelect
  },
  data () {
    return {
      reportServer: process.env.VUE_APP_REPORT_SERVER,
      form:{
        year: getReportDate().year,
        month: getReportDate().month,
        project: "",
        curriculum: "",
        loanType: "",
        educationStatus: "",
      },
      user: ""
    }
  },
  computed: {
    ...mapReportState([ 'status']),
    ...mapMasterState(["curriculums", "months"]),
    ...mapGetters({
      yearsOptions: "Master/yearsOptions",
      monthsOptions: "Master/monthsOptions",
      projectOptions: "Master/projectOptions",
      facultyCurriculumOptions: "Master/facultyCurriculumOptions",
      loanTypesOptions: "Master/loanTypesOptions",
      educationStatusesOptions: "Master/educationStatusesOptions",
    }),
  },
  methods: {
    ...mapMasterActions(['onChangeYears', 'getProjectOptions', 'getCurriculumOptions']),
    _onChangeYears(e) {
      this.onChangeYears(e)
    },
    async loadOptions() {
      const vm = this
      const { getProjectOptions, getCurriculumOptions } = vm
      if(vm.projectOptions.length === 0) await getProjectOptions()
      if(vm.facultyCurriculumOptions.length === 0) await getCurriculumOptions()
    },
    async initData() {

    },
    async download (){
      const vm = this
      const params = {
        year: vm.form.year,
        month: vm.form.month,
        project: vm.form.project || '',
        curriculum: vm.form.curriculum || '',
        loanType: vm.form.loanType || 'Null',
        educationStatus: vm.form.educationStatus || 'Null',
        contractStatus: vm.form.contractStatus || 'Null',
      };

      const queryString = new URLSearchParams(params).toString();
      const { dialog } =vm.$vs
      dialog({
        type: 'confirm',
        color: 'danger',
        title: 'คำเตือนการเรียกรายงาน', // คุณต้องการเรียกรายงานใช่หรือไม่
        text: 'รายงานตัวดังกล่าวเป็นรายงานที่ใช้เวลาในการประมวลผลและทรัพยากรของระบบที่สูง ผู้เรียกรายงานต้องได้รับอนุญาตและได้รับการสอนการใช้งานก่อนดำเนินการเรียกรายงาน คำเตือนห้ามเรียกรายงานดังกล่าวซ้ำๆ หากติดปัญหาในการเรียกรายงานรบกวนแจ้งเจ้าหน้าทีผู้ดูแลระบบ คุณต้องการเรียกรายงานใช่หรือไม่!!',
        acceptText: 'ใช่',
        accept: async () => {
          const code = Math.floor(1000 + Math.random() * 9000);
          const inputCode = prompt("กรุณากรอกรหัสยืนยัน "+code+" เพื่อยืนยันการดำเนินการ", "");
          if (code === parseInt(inputCode)) {
            window.open(`${vm.reportServer}/excel/reportAccounting?${queryString}`, '_blank');
            vm.$vs.notify({
              title: 'รายงานกำลังดำเนินการ',
              text: 'ระบบกำลังดำเนินการเรียกรายงาน กรุณารอสักครู่...',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          } else {
            vm.$vs.notify({
              title: 'รหัสยืนยันไม่ถูกต้อง',
              text: 'กรุณากรอกรหัสยืนยันให้ถูกต้อง',
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        }
      })
    },
    async reset(){
      this.form = {
        year: moment().add(-1, 'M').format("YYYY"),
        month: parseInt(moment().add(-1, 'M').format("MM"))-1,
        educationStatus: '',
        loanType: '',
        project: '',
        curriculum: '',
      }
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  async created() {
    const vm = this
    vm.$vs.loading();
    await vm.loadOptions();
    await vm.initData();
    vm.$vs.loading.close();
  },
}
</script>
